import React from 'react';
import styled from 'styled-components';

import { ISimilarBlog } from '@/types/blog';
import { formatDate } from '@/helpers/formatDate';
import { devices } from '@/styles/breakpoints';
import { SmallCard, ISmallCardItem } from './SmallCard';

interface IProps {
  items: ISimilarBlog[];
}

export const SimilarArticles = ({ items }: IProps) => {
  if (!items?.length) return null;

  return (
    <Wrapper>
      <Title>Similar Articles</Title>
      <Grid>
        {items.map((item) => {
          const cardItem: ISmallCardItem = {
            slug: item.slug,
            title: item.title,
            meta_description: item.meta_description,
            mainImage: item.mainImage,
            time_to_read: item.time_to_read,
            formattedDate: formatDate(String(item.updated_at)),
          };
          return <SmallCard key={item.slug} item={cardItem} />;
        })}
      </Grid>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  margin-top: 48px;
  width: 100%;
`;

const Title = styled.h2`
  color: #192d52;
  font-family: var(--font-roboto);
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  margin-bottom: 24px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;

  @media only screen and ${devices.desktop} {
    grid-template-columns: 1fr 1fr;
  }
`;
